<template lang="html">
  <transition name="move">
    <div class="login" ref="login">
        <div class="login-wrapper">
            <div class="login-wrapper-auot">
              <!-- 登录 -->
                <span class ="logintet">{{ $t('signin') }}</span>
                <div class="logdata">
                    <div class="logdata-str">
                      <!-- 姓名 -->
                        <span>{{ $t('username') }}：</span>
                    </div>
                    <input  class="logdata-input"   v-model="username" v-model.lazy='uname'/> <span class="uname-tip">{{tip}}</span>
                </div>
                 <div class="logdata">
                    <div class="logdata-str">
                      <!-- 密码 -->
                        <span>{{ $t('password') }}：</span>
                    </div>
                    <input type="password" class="logdata-input"   v-model="pw"/>
                </div>
                 <!-- <div class="logdata">
                    <div class="logdata-str"> -->
                      <!-- 验证码 -->
                        <!-- <span>{{ $t('captcha') }}</span>
                    </div>
                    <input  class="logdata-input"   v-model="code"/>
                </div> -->
                <div class="logdata-newuser">
                  <input id="newuser" class="checkbtn" type="checkbox" v-model="isNewUser" > 
                  <label v-if="isNewUser==false" for="newuser" class="label-newuser">{{ $t('newuser') }}</label>
              </div> 
                <div v-if="isNewUser==false" class="logdata-msg" @click="login($event)">
                    <span class="pay">
                        <!-- 登录 -->
                        {{ $t('signin') }}
                    </span>
                </div>
                <div v-else class="logdata-msg" @click="newuser($event)">
                    <span class="pay">
                        <!-- 注册 -->
                        {{ $t('newuser') }}
                    </span>
                </div>
                <div class="logdata-err">
                  <span>{{ tip2 }}</span>
                </div> 
                <div class="detail-close" @click="loginHide">
                  <i class="icon-close"></i>
                </div>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import {Encrypt} from 'common/js/secret.js'
import eventbus from '../../common/js/eventbus.js'

export default {
  props: {
  },
  data() {
    return {
      username: '',
      uname: '',
      tip: '',
      pw: '',
      code: '',
      islogining: false,
      tip2: '',
      state: this.$store.state,
      isNewUser: false,
      myinfo: {
        id: 1,
        SellerID: 1,
        openId: '',
        name: 'Guest',
        hash: '',
        addres: []
      }
    }
  },
  updated() {
  },
  methods: {
    checkName: function(uname) {
      if (this.isNewUser === false) return
      // var that = this
      // // 调用接口，但是可以使用定时任务的方式模拟接口的调用
      // setTimeout(function() {
      //   // 模拟接口调用
      //   if (uname === 'admin') {
      //     that.tip = '用户名已存在，请重新输入'
      //   } else {
      //     that.tip = '恭喜你输入的用户名可以使用'
      //   }
      // }, 2000)
      // 调用接口，但是可以使用定时任务的方式模拟接口的调用
      this.$http.get(this.api.checkUserExist + encodeURIComponent(Encrypt(uname)) + this.state.ibnumber)
      .then((res) => {
        if (this.$store.state.dev) console.log('检查用户名', res.data)
        if (res.data.code === 99) {
          this.tip = this.$tc('newusertips', 1) // '用户名已存在，请重新输入'
        } else if (res.data.code === 0) {
          this.tip = this.$tc('newusertips', 2) // '恭喜你输入的用户名可以使用'
        }
      })
      .catch(err => {
        alert(this.$t('loginerror3') + ` code ${err}`)
      })
    },
    autoResetMsg(t) {
      if (this.$store.state.dev) console.log('--autoResetMsg--', this.tip2)
      // let _this = this
      // setTimeout(function () {
      //   _this.tip2 = ''
      // }, t)
    },
    checkinfo() {
      if (this.islogining) return false
      if (this.username === null || this.username === '') this.tip2 = this.$t('loginerror0') // '请输入用户名'
      else if (this.pw === null || this.pw === '') this.tip2 = this.$t('loginerror1') // '请输入密码'
      // else if (this.code === null || this.code === '') this.tip2 = this.$t('loginerror2') //'请输入验证码'
      else this.tip2 = ''
      this.autoResetMsg(1500)
      if (this.$store.state.dev) console.log('--登录检查资料--', this.tip2)
      if (this.tip2 !== null && this.tip2 !== '') { return false } else { return true }
    },
    newuser(e) {
      if (this.$store.state.dev) console.log('1.注册点击', this)
      if (this.checkinfo() === false) return
      this.islogining = true

     // 注册
      if (this.$store.state.dev) console.log('2.注册', this.state.myinfo)
      this.state.myinfo = {
        ID: 0,
        SellerID: 1,
        openId: '',
        description: this.username,
        username: this.username,
        name: this.username,
        hash: Encrypt(this.pw),
        addres: []
      }
      this.$http.post(this.api.createUser, this.state.myinfo)
            .then(res => {
              if (res.data.code === 0) {
                this.state.myinfo = res.data.data[0]
                if (this.$store.state.dev) console.log('3.注册后', this.state.myinfo)
                this.state.uuid = this.state.myinfo.openId
                this.$store.dispatch('saveinfo', this.state)
                eventbus.$emit('refresh_myinfo', this.state.myinfo)
                this.$router.push('/mymessage')
              } else {
                if (res.data.code === 99) {
                  this.tip2 = this.$t('loginerror6') // 用户名已存在
                } else {
                  this.tip2 = this.$t('loginerror4') // `注册失败`
                }
                this.islogining = false
                console.error('3.保存地址', this.tip2, res.data.message)
                this.autoResetMsg(3500)
              }
            })
            .catch(err => {
              this.tip2 = this.$t('loginerror4') // `注册失败`
              this.islogining = false
              console.error('3.保存地址', err.response.message)
              this.autoResetMsg(3500)
              return
            })

      this.pw = ''
      this.code = ''
      this.islogining = false
      this.isNewUser = false
    },
    login(e) {
      if (this.$store.state.dev) console.log('1.登录点击', this)
      if (this.checkinfo() === false) return
      this.islogining = true

      // 登录
      if (this.$store.state.dev) console.log('2.登录', this.state.myinfo)
      this.$http.get(this.api.getUser + '?username=' + encodeURIComponent(Encrypt(this.username || '1')) + '&hash=' + encodeURIComponent(Encrypt(this.pw || '')) + '&SellerID=' + (this.code || '1') + this.state.ibnumber)
      .then((res) => {
        if (res.data.data[0] === undefined) {
          this.tip2 = this.$t('loginerror3') // `登录失败`
          this.islogining = false
          if (this.$store.state.dev) console.log('3.登录失败', this.state.myinfo)
          this.autoResetMsg(3500)
          return
        } else {
          this.state.myinfo = res.data.data[0]
          if (this.$store.state.dev) console.log('3.登录后', this.state.myinfo)
          this.state.uuid = this.state.myinfo.openId
          // this.$router.go(-1)
          this.$store.dispatch('saveinfo', this.state)
          eventbus.$emit('refresh_myinfo', this.state.myinfo)
          this.$router.push('/mymessage')
          // this.islogining = false
          if (this.$store.state.dev) console.log('4.跳转', this.state.myinfo)
        }
      })
      .catch(err => {
        alert(this.$t('loginerror3') + ` code ${err}`)
      })

      this.pw = ''
      this.code = ''
      this.islogining = false
    },
    postfun() {
      // 跳转商品页面
      // this.$router.push('/goods')
      this.$store.dispatch('saveinfo', this.state)
      this.refresh()
      // 退一部
      this.$router.go(-1)
    },
    loginHide() {
      this.$router.go(-1)
    }
  },
  created() {
    // var enc = Encrypt('alex')
    // console.log('Ticket', Encrypt('alex'))
    // console.log('Ticket2', Decrypt(enc))
  },
  components: {
  },
  watch: {
    uname: function(val) {
      if (this.isNewUser === false) return
      // 调用后台接口验证用户名的合法性
      this.checkName(val)
      // 修改提示信息
      this.tip = '正在验证用户名...'
    }
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.login {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    background: rgba(7, 17, 27, 0.5);
    &.move-enter-active,
    &.move-leave-active {
        // 动画过程
        transition: all 0.5s;
        transform: translate3d(0, 0, 0);
    }
    &.move-enter,
    &.move-leave-to {
        // 动画初始态
        transform: translate3d(100%, 0, 0);
    }

    .login-wrapper {
        border-radius: 10px;
        position: absolute;
        /* right: auto; */
        bottom: 10%;
        top: 10%;
        left: 10%;
        width: 80%;
        height: 450px;
        margin: auto;
        background-color: #fff;
        .login-wrapper-auot {
            width: 80%;
            margin: auto;
            height: 100px;
            .logintet {
                display: block;
                font-size: 30px;
                color: #4b2354;
                line-height: 1.2;
                text-align: center;
                padding: 20px 0px;
                @include border-1px(rgba(7, 17, 27, 0.1));
            }

            .logdata {
                position: relative;
                padding: 12px 0;
                box-sizing: border-box;
                @include border-1px(rgba(7, 17, 27, 0.1));
                .logdata-input {
                    display: flex;
                    padding: 2%;
                    width: 96%;
                    line-height: 24px;
                    background: #f7f7f7;
                    border: 1px solid #ced4da;
                    border-radius: 0.25rem;
                }
                .logdata-str {
                    display: flex;
                    width: 100%;
                    line-height: 24px;
                    color: #000;
                }

                .uname-tip {  
                    color: gray;
                    font-size: 9px;
                    margin: 3px;
                }
            }

            .logdata-err {
                width: 100%;
                position: relative;
                top: 65px;
                text-align: center;
                color: red;
            }
            .logdata-newuser {
                width: 100%;
                position: relative;
                top: 15px;
                .checkbtn {
                    height: 16px;
                    width: 16px;
                    color: rgb(0, 180, 60);
                }
                .label-newuser {
                    width: 100%;
                    position: relative;
                    left: 5px;
                }
            }
            .logdata-msg {
                background: #00b43c;
                border-radius: 10px;
                position: relative;
                width: 100%;
                overflow: hidden;
                height: 40px;
                top: 40px;
                text-align: center;
                .pay {
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 700;
                    color: #fff;
                    &.not-enough {
                        background: #2b333b;
                    }
                    &.enough {
                        background: #00b43c;
                        color: #fff;
                    }
                }
            }
            .detail-close {
                // background: green;
                width: 32px;
                height: 32px;
                // margin-top: -64px auto 0 auto;
                font-size: 32px;
                line-height: 32px;
                clear: both;
                top: 10px;
                right: 10px;
                position: absolute;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// login.vue?498ebaae